import { useState } from 'react'
import { Paper } from '../../../../ui/index'
import SavedCardsList from './SavedCardsList'
import PaymentHistory from './PaymentHistory'
import PlansList from './PlansList'

const Pagos = () => {
  const [activeTab, setActiveTab] = useState('plans')

  return (
    <Paper>
      <div className="p-6">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-sans font-bold text-gray-800">Gestión de Planes y Pagos</h2>
        </div>

        <div className="flex gap-4 mb-6 border-b overflow-x-auto">
          <button
            onClick={() => setActiveTab('plans')}
            className={`px-4 py-2 font-sans font-semibold whitespace-nowrap ${
              activeTab === 'plans'
                ? 'border-b-2 border-primary text-primary'
                : 'text-gray-600 hover:text-gray-800'
            }`}
          >
            Planes
          </button>
          <button
            onClick={() => setActiveTab('cards')}
            className={`px-4 py-2 font-sans font-semibold whitespace-nowrap ${
              activeTab === 'cards'
                ? 'border-b-2 border-primary text-primary'
                : 'text-gray-600 hover:text-gray-800'
            }`}
          >
            Tarjetas Guardadas
          </button>
          <button
            onClick={() => setActiveTab('history')}
            className={`px-4 py-2 font-sans font-semibold whitespace-nowrap ${
              activeTab === 'history'
                ? 'border-b-2 border-primary text-primary'
                : 'text-gray-600 hover:text-gray-800'
            }`}
          >
            Historial de Pagos
          </button>
        </div>
        {activeTab === 'plans' && <PlansList />}

        {activeTab === 'cards' && <SavedCardsList />}

        {activeTab === 'history' && <PaymentHistory />}
      </div>
    </Paper>
  )
}

export default Pagos
